import { classNames } from 'primereact/utils';
import {
  AccordionContext,
  AccordionPassThroughOptions,
  AccordionTabPassThroughOptions,
  AccordionTabProps,
} from 'primereact/accordion';

const TRANSITIONS = {
  toggleable: {
    timeout: 500,
    classNames: {
      enter: 'ax-toggleable-content__enter',
      enterActive: 'ax-toggleable-content__enter-active',
      enterDone: 'ax-toggleable-content__enter-done',
      exit: 'ax-toggleable-content__exit',
      exitActive: 'ax-toggleable-content__exit-active',
    },
  },
};

const PTAccordionTab: AccordionTabPassThroughOptions = {
  root: {
    className: 'ax-accordion mb-1',
  },
  header: ({ props }: { props: AccordionTabProps }) => ({
    className: classNames(
      'ms-4',
      {
        'select-none pointer-events-none cursor-default opacity-60':
          props?.disabled,
      }, // Condition
    ),
  }),
  headerAction: ({ context }: { context: AccordionContext }) => ({
    className: classNames(
      'ax-accordion__header-action',
      'flex items-center cursor-pointer relative no-underline select-none', // Alignments
      'px-4 py-3 transition duration-200 ease-in-out rounded-t-md font-bold transition-shadow duration-200', // Padding and transition
      {
        'ax-accordion__header-action--not-selected': !context?.selected,
        'ax-accordion__header-action--selected': context?.selected,
      },
      {
        'ax-accordion__header-action--disabled': context.disabled,
      },
    ),
  }),
  headerIcon: {
    className: 'hidden',
  },
  headerTitle: {
    className: 'leading-none text-xl',
  },
  content: {
    className: classNames('ax-accordion__content p-3'),
  },
  transition: TRANSITIONS.toggleable,
  toggleableContent: {
    className: 'ax-accordion__toggleable-content',
  },
};

export const PTAccordion: AccordionPassThroughOptions = {
  root: {
    className: 'mb-1',
  },
  accordiontab: { ...PTAccordionTab },
};
